export class OpnTeamMemberModel {
  id: number;
  userId: number;
  organizationalUnit: string;
  fullName: string;
  employeePosition: string;
  assessmentArea: string;
  personnelArea: string;
  isGivenCompliance: boolean;
  complianceDate: Date;
}

export class OpnTeamMemberSaveModel {
  requestId: number;
  userId: number;
  selectedAssessmentAreaIds: number[];
}
